/* global axios */
import ApiClient from '../ApiClient';

class EvolutionChannel extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // Crea una nueva instancia de Evolution API con los parámetros proporcionados
  connectEvolutionInstance(params) {
    return axios.post(
      `${this.baseUrl()}/inboxes/connect_evolution_instance`,
      params
    );
  }

  // Crea una nueva instancia de Evolution API con los parámetros proporcionados
  createEvolutionInstance(params) {
    return axios.post(
      `${this.baseUrl()}/inboxes/create_evolution_instance`,
      params
    );
  }

  // Desvincula una instancia de Evolution API con los parámetros proporcionados
  unlinkEvolutionInstance(params) {
    return axios.post(
      `${this.baseUrl()}/inboxes/unlink_evolution_instance`,
      params
    );
  }
}

export default new EvolutionChannel();
